exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/transition-matrix/transition-matrix.component.css
// module id = ../../../../../src/app/base/components/canvas/components/transition-matrix/transition-matrix.component.css
// module chunks = main